import { userStore } from '../store';
import { getKeyValue } from '../store/common/localStorageManager';

export const request = async ({
  url,
  method,
  data,
  headers,
  flag,
  isNotJsonType,
}: { url: string, method: string, data?: any, headers?: any, flag?: boolean,isNotJsonType?:boolean }) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000); // ⏱ 设置30秒超时

  let _headers = {
    ...headers,
    "x-access-id": userStore.state.userId || getKeyValue('userId'),
    "x-access-role": userStore.state.role || getKeyValue('role'),
    "x-access-role-id": userStore.state.roleId || getKeyValue('roleId'),
    "x-access-tenant": userStore.state.tenantId || getKeyValue('tenantId'),
    "x-access-token": userStore.state.token || getKeyValue('token'),
    "x-access-lang": userStore.state.lang || getKeyValue('lang')
  };
  if (!isNotJsonType) {
    // 文件上传等非json格式
    _headers['Content-Type']='application/json'
  }
  let host = _get(window, "application_config.WEB_API_HOST") || _get(window, "location.ancestorOrigins[0]");
  let address = `${host}/web-api${url}`;
  if (url.startsWith("http")){
    address = url
  }

  try {
    let response = await fetch(address, {
      method: method,
      headers: _headers,
      body: flag ? data : JSON.stringify(data),
      signal: controller.signal // ✅ 加入 signal
    });
    clearTimeout(timeout); // ✅ 清除定时器.
    return await response.json();
  } catch (err) {
    clearTimeout(timeout); // ✅ 确保异常时也清除定时器
    console.error("请求失败或超时:", err);
    throw err;
  }
};



export const JSON_HEADER = () => {
  return {
    'Content-Type': 'application/json'
  }
}
export const requestHeaders = () => {
  return {
    'x-access-id': getKeyValue('userId'),
    'x-access-tenant': getKeyValue('tenantId'),
    'x-access-role-id': getKeyValue('roleId'),
    'x-access-role': getKeyValue('role'),
    'x-access-token': getKeyValue('token'),
  };
}



